<template>
  <!--
      	作者：qjy
      	时间：2019-06-04
      	描述：插件中心-elasticsearch-设置
      -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" :model="esConfig" ref="ruleForm" label-width="100px">
      <div class="open-sign">
        <span class="gray9">是否开启专业搜索</span>
        <el-switch v-model="esConfig.isOpen" class="ml10"></el-switch>
      </div>
      <div class="common-button-wrapper"><el-button type="primary" size="small" @click="onSubmit"  :loading="loading">提交</el-button></div>
    </el-form>

    <el-card v-show="esConfig.isOpen" class="box-card">
      <div class="sync-box">
        <el-button type="primary" :loading="esAsyncLoading" @click="oneClickSync">一键同步<i class="el-icon-refresh"></i></el-button>
      </div>

      <el-steps class="steps" :active="3">
        <el-step :title="dbCountTitle" icon="el-icon-coin"></el-step>
        <el-step title="" :icon="statusIcon"></el-step>
        <el-step :title="esCountTitle" icon="el-icon-search"></el-step>
      </el-steps>
    </el-card>
  </div>
</template>

<style>
.box-card{
  margin-top: 15px;
}
.sync-box{
  text-align: center;
}
.steps{
  margin-top: 25px;
}
</style>

<script>
  import elasticsearchApi from '@/api/elasticsearch.js'
  export default {
    data() {
      return {
        /*表单数据对象*/
        esConfig: {
          isOpen: false
        },
        dbCount: 2,
        esCount: 1,
        loading: false,
        esAsyncLoading: false
      };
    },
    computed:{
      dbCountTitle:function(){
        return '本地库(' + this.dbCount + ')'
      },
      esCountTitle:function(){
        return '搜索库(' + this.esCount + ')'
      },
      isAsync:function(){
        return this.dbCount === this.esCount
      },
      statusIcon: function (){
        return this.isAsync ? 'el-icon-folder-checked' : 'el-icon-folder-delete'
      }
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        let self = this;
        elasticsearchApi.esDetail({}, true)
          .then(data => {
            self.esCount = data.data.res.esCount
            self.dbCount = data.data.res.dbCount
            self.esConfig = data.data.res.esConfig
          })
          .catch(error => {});
      },
      //提交表单
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.esConfig;
        elasticsearchApi.editConfig(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，上传设置成功',
              type: 'success'
            });
          })
          .catch(error => {
            self.loading = false;
          });
      },
      //监听单选按钮
      getRadio(val) {},
      oneClickSync(){
        this.esAsyncLoading = true
        elasticsearchApi.oneClickSync().then(data => {
          this.esAsyncLoading = false
          this.getData()
          this.$notify.success('同步成功')
        }).catch(err => {
          this.esAsyncLoading = false
        })
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/plus/elasticsearch/icp/setting.vue